import { Alert, Box, Divider, Grid, Paper, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import UserContext from "../../../navigation/context/userContext";
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GetImagenes } from "../../../controllers/company/CompanyProfileController";
import { Dropzone, FileMosaic, FullScreen, ImagePreview } from "@files-ui/react";

export default function CompanyProfileImages() {
    const { userData } = useContext(UserContext);

    const [logoUrl, setLogoUrl] = useState('');
    const [logoFile, setLogoFile] = useState([]);

    const [coverUrl, setCoverUrl] = useState('');
    const [coverFile, setCoverFile] = useState([]);

    const [imgPreviewSrc, setImgPreviewSrc] = useState(undefined);

    const [message, setMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        getImagenes();
    }, []);

    const handleSee = (imageSource) => {
        setImgPreviewSrc(imageSource);
    };

    // --- MANEJO DEL LOGO ---
    const updateLogoFile = async (incommingFiles) => {
        setLogoFile(incommingFiles);
        // Validamos que el archivo exista antes de enviarlo
        if (incommingFiles.length > 0 && incommingFiles[0].file) {
            UpdateImagen('imagenRecuadro', incommingFiles[0].file);
        }
    };

    const removeLogoFile = (id) => {
        setLogoFile(logoFile.filter((x) => x.id !== id));
    };

    // --- MANEJO DE LA PORTADA ---
    const updateCoverFile = async (incommingFiles) => {
        setCoverFile(incommingFiles);
        if (incommingFiles.length > 0 && incommingFiles[0].file) {
            UpdateImagen('imagenFondo', incommingFiles[0].file);
        }
    };

    const removeCoverFile = (id) => {
        // BUG CORREGIDO: Antes estabas filtrando "logoFile" en lugar de "coverFile"
        setCoverFile(coverFile.filter((x) => x.id !== id));
    };

    // --- FUNCIÓN DE SUBIDA (WEB) ---
    const UpdateImagen = async (variable, valor) => {
        console.log("Revisando el archivo a enviar:", valor);
        var token = 'Bearer ' + userData.token;
        var data = new FormData();
        
        // En la web, simplemente pasamos el objeto File directamente
        data.append(variable, valor);

        try {
            let response = await fetch(CompanyRoutes.Profile.UpdatePicture, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    // El Content-Type se genera solo en la web, dejarlo comentado es correcto
                    'Authorization': token,
                },
                body: data
            });

            let responseJson = await response.json();

            if (responseJson.success === true) {
                setShowAlert(true);
                setMessage(responseJson.message);
                
                // BUG CORREGIDO: setTimeout no es una promesa, no lleva "await"
                setTimeout(() => {
                    setShowAlert(false);
                }, 7000);
            }
        } catch (error) {
            // BUG CORREGIDO: this.setState no existe en componentes funcionales
            alert("Error al subir la imagen: " + error);
        }
    };

    // --- CARGA INICIAL DE IMÁGENES ---
    const getImagenes = async () => {
        let response = await GetImagenes();
        if (response.success === true) {
            if (response.data.imgFondo !== null) {
                setCoverUrl(response.data.imgFondo);
            }

            if (response.data.imgRecuadro !== null) {
                // BUG CORREGIDO: Antes decía setLogoUrl(imgRecuadro) (variable vacía) 
                // en lugar de usar la respuesta del servidor
                console.log('LOGO ===> ',response.data.profile_image)
                setLogoUrl(response.data.profile_image);
            }
        }
    };

    return (
        <Paper elevation={4} sx={{ p: 3 }}>
            
            {/* Opcional: Mostrar la alerta si fue exitoso */}
            {showAlert && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    {message}
                </Alert>
            )}

            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Typography variant="h6" fontWeight={'bold'}>Logo</Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>Se recomienda una imagen cuadrada ejemplo 512x512 px</Typography>

                    <Dropzone
                        onChange={updateLogoFile}
                        label="Imagen de perfil"
                        value={logoFile}
                        accept="image/*"
                        maxFileSize={512 * 1024}
                        maxFiles={1}
                        behaviour="replace"
                        cleanFiles
                        actionButtons={{ position: "bottom", cleanButton: {} }}
                        localization="ES-es"
                    >
                        {logoFile.length > 0 ? (
                            logoFile.map((file) => (
                                <FileMosaic
                                    key={file.id}
                                    {...file}
                                    onSee={handleSee}
                                    onDelete={removeLogoFile}
                                    info
                                    preview
                                    smartImgFit="center"
                                />
                            ))
                        ) : (
                            <Box sx={{ width: { xs: 150, sm: 200, md: 200, lg: 250, xl: 250 }, height: { xs: 150, sm: 200, md: 200, lg: 250, xl: 250 }, p: 2 }}>
                                {logoUrl ? <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={logoUrl} alt={'Logo QUD'} /> : <Typography color="textSecondary">Sin imagen</Typography>}
                            </Box>
                        )}
                    </Dropzone>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Typography variant="h6" fontWeight={'bold'}>Foto de portada</Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>Se recomienda una imagen rectangular ejemplo 800 x 866 px</Typography>
                    
                    <Dropzone
                        onChange={updateCoverFile}
                        label="Imagen de portada"
                        value={coverFile}
                        accept="image/*"
                        maxFileSize={512 * 1024}
                        maxFiles={1}
                        behaviour="replace"
                        cleanFiles
                        actionButtons={{ position: "bottom", cleanButton: {} }}
                        localization="ES-es"
                    >
                        {coverFile.length > 0 ? (
                            coverFile.map((file) => (
                                <FileMosaic
                                    key={file.id}
                                    {...file}
                                    onSee={handleSee}
                                    onDelete={removeCoverFile}
                                    info
                                    preview
                                    smartImgFit="center"
                                />
                            ))
                        ) : (
                            <Box sx={{ width: { xs: 240, sm: 200, md: 200, lg: 250, xl: 400 }, height: { xs: 260, sm: 217, md: 217, lg: 271, xl: 433 }, p: 2 }}>
                                {coverUrl ? <img style={{ width: '100%', height: '100%', objectFit: 'contain' }} src={coverUrl} alt={'Portada QUD'} /> : <Typography color="textSecondary">Sin portada</Typography>}
                            </Box>
                        )}
                    </Dropzone>
                </Grid>

                <FullScreen open={imgPreviewSrc !== undefined} onClose={() => setImgPreviewSrc(undefined)}>
                    <ImagePreview src={imgPreviewSrc} />
                </FullScreen>
            </Grid>
        </Paper>
    );
}